<nz-slider [(ngModel)]="config.value" [nzDisabled]="config.disabled"></nz-slider>
